exports["IE"] = require("./IE.js");
exports["UK"] = require("./UK.js");